import { PostHogProvider } from "posthog-js/react";
import { FC, PropsWithChildren } from "react";

import { env } from "@/env";

const PosthogProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <PostHogProvider
      apiKey={env.NEXT_PUBLIC_POSTHOG_API_KEY}
      options={{ api_host: env.NEXT_PUBLIC_POSTHOG_HOST, person_profiles: "identified_only" }}
    >
      {children}
    </PostHogProvider>
  );
};

export { PosthogProvider };
